<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>

<div class="d-none">VERSION: {{ appVersion }}</div>
